import {
  DELETE_DOCUMENTOS_MATERIAL_URL,
  GET_DOCUMENTOS_BY_ID_URL,
  GET_DOCUMENTOS_URL,
  POST_DOCUMENTOS_URL
} from 'enums/URLS/urlsApiDocumentos'
import { api_documentos } from 'services/apis'
import { PostDocumentoParams } from 'types/documentos'
import { DeleteDocumentApprovalParams, DocResponse, MaterialApoio } from 'types/material-apoio'

export const getDocumentos = async (name?: string): Promise<MaterialApoio[]> => {
  name = name || ''
  const response = await api_documentos.get(GET_DOCUMENTOS_URL({ name }))
  const data = response.data.data as MaterialApoio[]
  return data
}

export const getDocumentoById = async (id: number) => {
  const response = await api_documentos.get(GET_DOCUMENTOS_BY_ID_URL({ id_corcc080: id }))
  const data = response.data.data as DocResponse
  return data
}

export const deleteSuportMaterialById = async ({
  id_corcc132,
  id_corcc080
}: DeleteDocumentApprovalParams) => {
  const response = await api_documentos.delete(
    DELETE_DOCUMENTOS_MATERIAL_URL({ id_corcc132, id_corcc080 })
  )
  const data = response.data.data
  return data
}

export const postDocumento = async ({ doc, onUploadProgress }: PostDocumentoParams) => {
  const response = await api_documentos.post(POST_DOCUMENTOS_URL, doc, { onUploadProgress })
  const data = response.data
  return data
}
